const axios = require('axios')
const errorHandler = require('./error-handler')

export default {
  async consumeReferral (data) {
    return axios.post('/api/referrals/consume', data)
      .then(r => r.data).catch(errorHandler)
  },
  async createUserReferral (data) {
    return axios.post('/api/referrals/user', data)
      .then(r => r.data).catch(errorHandler)
  },
  async createEmailReferral (data) {
    return axios.post('/api/referrals/email', data)
      .then(r => r.data).catch(errorHandler)
  },
  async consumeUserReferral (data) {
    return axios.post('/api/referrals/user/consume', data)
      .then(r => r.data).catch(errorHandler)
  },
  async consumeEmailReferral (data) {
    return axios.post('/api/referrals/email/consume', data)
      .then(r => r.data).catch(errorHandler)
  },
  async get () {
    return axios.get('/api/referrals')
      .then(r => r.data).catch(errorHandler)
  },
  async getForJob (jobId) {
    return axios.get(`/api/referrals/job/${jobId}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getLink (jobId) {
    return axios.get(`/api/referrals/getlink/${jobId}`)
      .then(r => r.data).catch(errorHandler)
  },
  async getStats () {
    return axios.get(`/api/referrals/stats`)
      .then(r => r.data).catch(errorHandler)
  },
  async getHired () {
    return axios.get(`/api/referrals/hired`)
      .then(r => r.data).catch(errorHandler)
  }
}



// WEBPACK FOOTER //
// ./src/api/referrals.js